import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {AccountsService} from "../../services/accounts-service.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";

export class AccountAvatarCtrl implements IController {

  account: AccountModel;
  size: any;
  canDelete: boolean;
  doUpload: any;
  onDelete: Function;

  private sizeLimit: number;//kb

  /* @ngInject */
  constructor(private accountsService: AccountsService, public commonsAlertsService: CommonsAlertsService) {
  }

  $onInit() {
    if (_.isUndefined(this.doUpload)) {
      this.doUpload = false;
    }

    this.sizeLimit = 500;
  }

  onUpload = (result) => {
    const imageUrl = _.get(result, 'data.url');
    const accountCopy = angular.copy(this.account);

    _.set(accountCopy, 'avatarUrl', imageUrl);

    this.accountsService.updateOne(this.account.id, accountCopy)
      .then((updatedAccount) => {
        // ctrl.account = updatedAccount;
      })
  }

  onSizeMismatch = () => {
    this.commonsAlertsService.fileSizeError();
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('accountAvatar', {
    bindings: {
      account: '<',
      canDelete: '<?',
      size: '@',
      doUpload: '<?',
      onDelete: '&'
    },
    template: require('./account-avatar.html').default,
    controller: AccountAvatarCtrl
  });
